const translations = {
    account: 'Account'
};

export default translations;
